import UrlConst from '../../constants/UrlConst';

import apiClient from '../common/apiClient';
import { makeEndpoint, makeGetRequestSettings } from '../common/utils';

export const restGetSHPLayers = (): Promise<any> =>
    apiClient.sendWithoutErrorsHandling(
        makeGetRequestSettings(makeEndpoint(UrlConst.MAP_SHP_LAYERS, ''))
    );
